<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TimelineDetailZchDrawer',
})
</script>
<template>
  <Drawer v-model:visible="visible" title="详情" width="1000px" destroyOnClose>
    <Skeleton :loading="loading" active :paragraph="{ rows: 10 }">
      <Detail :record="result" />
    </Skeleton>
  </Drawer>
</template>

<script lang="ts" setup name="TimelineDetailZchDrawer">
import { Drawer, Skeleton } from 'ant-design-vue'
import { ref } from 'vue'
import { useFetch } from '@/hooks/useFetch'
import { API_JT_ZCH_DETAIL } from '@/api/jtZch'
import { API_GY_ZCH_DETAIL } from '@/api/gyZch'
import Detail from './index.vue'
const props = withDefaults(
  defineProps<{
    isGy?: boolean
  }>(),
  {
    isGy: false
  }
)
const visible = ref(false)
const { result, loading, fetchData } = useFetch({
  getFn: (props.isGy ? API_GY_ZCH_DETAIL : API_JT_ZCH_DETAIL) as any,
  isShallow: true
})

const open = (id: string) => {
  visible.value = true
  fetchData(id)
}
defineExpose({
  open,
  result
})
</script>
